<div
  *ngIf="loadingSignOff$ | async; else loadedContent"
  class="formgrid p-fluid flex align-items-center justify-content-center py-8"
>
  <p-progressSpinner></p-progressSpinner>
</div>
<ng-template #loadedContent>
  <p-toast key="active_issues"></p-toast>

  <p-table
    #dt
    [value]="issueData"
    [rowHover]="true"
    scrollHeight="75vh"
    scrollDirection="vertical"
    [scrollable]="true"
    [lazy]="true"
    (onLazyLoad)="loadActiveIssues($event)"
    [contextMenu]="dt"
    [totalRecords]="totalRecords"
    [tableStyle]="{ 'min-width': '100%' }"
    styleClass="app-table p-datatable-sm lg:p-datatable-md"
    [globalFilterFields]="['vehicle_reference', 'descriptions.description']"
  >
    <ng-template pTemplate="caption">
      <div
        class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 py-2"
      >
        <!-- LEFT SIDE -->
        <div class="flex flex-wrap align-items-center gap-2">
          <!-- When items are selected -->
          <ng-container
            *ngIf="selectedDescription.length > 0; else defaultActions"
          >
            <span class="text-600 text-sm mr-2">
              {{ selectedDescription.length }} selected for
              {{ selectedVehicleReference }}
            </span>

            <button
              pButton
              type="button"
              icon="pi pi-check"
              label="Sign off"
              class="p-button-sm p-button-outlined"
              (click)="
                showSignOffModal(selectedDescription, selectedDescription)
              "
            ></button>

            <button
              pButton
              type="button"
              icon="pi pi-pencil"
              label="Update"
              class="p-button-sm p-button-text"
              (click)="showEditActiveIssueModal(selectedDescription)"
            ></button>

            <button
              pButton
              type="button"
              icon="pi pi-trash"
              label="Delete"
              class="p-button-sm p-button-text p-button-danger"
              (click)="confirmMultiDelete()"
            ></button>

            <button
              pButton
              type="button"
              icon="pi pi-times"
              label="Clear"
              class="p-button-sm p-button-text"
              (click)="clearActiveIssueSelection()"
            ></button>
          </ng-container>

          <!-- Default actions -->
          <ng-template #defaultActions>
            <button
              pButton
              type="button"
              icon="pi pi-plus"
              label="Add Active Issue"
              class="p-button-sm p-button-outlined"
              (click)="showAddActiveIssueModal()"
            ></button>

            <button
              pButton
              type="button"
              icon="pi pi-plus"
              label="Add Service Reminder"
              class="p-button-sm p-button-text"
              (click)="showCreateServiceReminder()"
            ></button>

            <button
              pButton
              type="button"
              icon="pi pi-file-export"
              label="Generate Reports"
              class="p-button-sm p-button-text"
              (click)="showReportDialog()"
            ></button>
          </ng-template>
        </div>

        <!-- RIGHT SIDE -->
        <div class="w-full md:w-auto">
          <span
            class="p-input-icon-left p-input-icon-right active-issue-search w-full"
          >
            <i
              class="pi pi-search active-issue-search__icon"
              aria-hidden="true"
            ></i>
            <input
              pInputText
              type="text"
              class="w-full md:w-20rem"
              [value]="activeIssueSearch"
              (input)="filterGlobal($event)"
              placeholder="Search keyword"
            />
            <button
              *ngIf="activeIssueSearch"
              type="button"
              class="active-issue-search__clear"
              aria-label="Clear active issue search"
              (click)="clearActiveIssueSearch()"
            >
              <i class="pi pi-times" aria-hidden="true"></i>
            </button>
          </span>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th
          *ngFor="let col of columns; let i = index"
          [pSortableColumn]="col.field"
          [style.width]="i === 0 ? '3.5rem' : 'auto'"
          class="min-w-0"
        >
          <div class="flex align-items-center gap-1 min-w-0 overflow-hidden">
            <span
              class="block min-w-0 overflow-hidden text-overflow-ellipsis white-space-nowrap"
            >
              {{ col.header }}
            </span>

            <p-columnFilter
              class="hidden md:inline-flex flex-shrink-0"
              type="text"
              [field]="col.field"
              display="menu"
            ></p-columnFilter>

            <p-sortIcon
              class="hidden md:inline-flex flex-shrink-0"
              [field]="col.field"
            ></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-issue>
      <tr (click)="handleCellClick($event)">
        <td class="frozen-column">
          <div class="flex align-items-center gap-2">
            <span class="font-medium text-md text-color-primary">
              {{ issue.vehicle_reference }}
            </span>

            <button
              pButton
              type="button"
              icon="pi pi-file-o"
              class="p-button-sm p-button-text"
              (click)="showNotesDialog(issue); handleCellClick($event)"
            ></button>
          </div>
        </td>

        <td class="max-w-full overflow-hidden">
          <div
            class="flex flex-wrap gap-2 max-w-full overflow-hidden"
            (click)="handleCellClick($event)"
          >
            <div
              *ngFor="let description of issue.descriptions"
              class="active-issue-chip max-w-full min-w-0"
              [class.active-issue-description--disabled]="
                isDescriptionSelectionDisabled(description)
              "
              [attr.title]="
                isDescriptionSelectionDisabled(description)
                  ? 'Only issues for ' +
                    selectedVehicleReference +
                    ' can be selected'
                  : null
              "
            >
              <div
                class="flex align-items-center gap-2 flex-1 min-w-0 overflow-hidden"
              >
                <p-checkbox
                  class="flex-shrink-0"
                  [value]="description"
                  [ngModel]="selectedDescription"
                  (ngModelChange)="onSelectedDescriptionsChange($event)"
                  [disabled]="isDescriptionSelectionDisabled(description)"
                  (click)="handleCellClick($event)"
                ></p-checkbox>

                <span
                  class="active-issue-chip__label cursor-pointer overflow-hidden text-overflow-ellipsis white-space-nowrap block min-w-0"
                  (click)="
                    openSignOffFromDescription($event, issue, description)
                  "
                >
                  {{ description.description }}
                </span>
              </div>

              <div class="flex align-items-center gap-1 flex-shrink-0">
                <button
                  pButton
                  type="button"
                  icon="pi pi-pencil"
                  class="p-button-sm p-button-text active-issue-chip__edit"
                  (click)="
                    showEditActiveIssueModal(description);
                    handleCellClick($event)
                  "
                ></button>

                <button
                  pButton
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-sm p-button-text p-button-danger active-issue-chip__delete"
                  (click)="confirmDelete(description); handleCellClick($event)"
                ></button>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="2">
          <div class="flex align-items-center justify-content-center">
            <span class="text-800 font-medium text-xl"> No active issues </span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-confirmDialog #cd>
    <p-footer>
      <button
        pButton
        type="button"
        label="No"
        class="p-button-primary"
        (click)="cd.reject()"
      ></button>
      <button
        pButton
        type="button"
        label="Yes"
        class="p-button-danger"
        (click)="cd.accept()"
      ></button>
    </p-footer>
  </p-confirmDialog>
</ng-template>
